export default __webpack_public_path__ + "static/media/Ravenclaw Armbands.f9c2e119.jpg";